import React, { useState, useEffect } from 'react';
import LoadingSpin from '../../loadingSpin/LoadingSpin';
import MasterBinService from '../../../services/Shared-Service/MasterBinService';
import BinTransitView from '../../Comman/BinTransitView/BinTransitView';
import { useNavigate } from 'react-router';

const BinTransitDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [binData, setBinData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await MasterBinService.masterBin_get_bins_details();
                const filteredData = response.data.filter(
                    (bin) => bin.bin_to === "washing" && bin.movement_status === "In Transit"
                  );
                  
                setBinData(filteredData);
                console.log("Fetched bin details:", response.data);
            } catch (error) {
                console.error("Error fetching bin details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleCardClick = (bin) => {
        console.log("Bin clicked:", bin);
        navigate(`/wash/dashboard/intransit/View?binId=${encodeURIComponent(bin.bin_id)}`);
    };

    return (
        <div>
            {loading ? <LoadingSpin /> : <>
                <BinTransitView binsToDisplay={binData} onCardClick={handleCardClick} />
            </>}
        </div>
    );
}

export default BinTransitDashboard;
